export default __webpack_public_path__ + "assets/images/play-819c460fda2b8b208a152e6742fdcfb8.svg";